import componentsInit from 'components';
import dataInit from 'data';
import ecommerceInit from 'ecommerce';
import editorInit from 'editor/init';
import i18n from 'internationalization';

import packageInfo from '../../../package.json';

import images from './specifications/images.json';
import i18nProducts from './specifications/i18n/products.json';

i18n.addResourceBundle('en', 'products', i18nProducts);

const SETTINGS = {
  APP_NAME: process.env.APP_NAME,
  APP_COPY: process.env.APP_COPY,
  DEBUG: false,
  BUILD_ID: process.env.BUILD_ID,
  HOST: process.env.HOST,
  API_HOST: process.env.API_HOST,
  TEMPLATE_HOST: process.env.TEMPLATE_HOST,
  API_GATEWAY_HOST: process.env.API_GATEWAY_HOST,
  CLIENT_ID: process.env.CLIENT_ID,
  VERSION: packageInfo.version,
  USER_AGENT: process.env.USER_AGENT,
  COOKIE_ACCESS_TOKEN_NAME: process.env.COOKIE_ACCESS_TOKEN_NAME,
  COOKIE_ACCESS_TOKEN_OPTIONS: {
    // TODO https://github.com/maticzav/nookies#setcookiectx-name-value-options-or-cookiessetctx-name-value-options
    maxAge: 30 * 24 * 60 * 60,
    path: '/',
  },
  COOKIE_COUNTRY_CODE_NAME: 'mycanvas.country.code',
  COOKIE_COUNTRY_CODE_OPTIONS: {
    // TODO https://github.com/maticzav/nookies#setcookiectx-name-value-options-or-cookiessetctx-name-value-options
    maxAge: 365 * 24 * 60 * 60,
    path: '/',
  },
  COOKIE_ALLOW_COOKIES_NAME: 'mycanvas.allow.cookies',
  COOKIE_ALLOW_COOKIES_OPTIONS: {
    // TODO https://github.com/maticzav/nookies#setcookiectx-name-value-options-or-cookiessetctx-name-value-options
    maxAge: 365 * 24 * 60 * 60,
    path: '/',
  },
  CLOUDINARY_ROOT_URL: process.env.CLOUDINARY_ROOT_URL,
  DEFAULT_COUNTRY_CODE: 'US',
  STRIPE_API_KEY: process.env.STRIPE_API_KEY,
  FACEBOOK_APP_ID: process.env.FACEBOOK_APP_ID,
  AMAZON_PAY_SELLER_ID: process.env.AMAZON_PAY_SELLER_ID,
  AMAZON_PAY_V2_STORE_ID: process.env.AMAZON_PAY_V2_STORE_ID,
  AMAZON_PAY_V2_PUBLIC_KEY_ID: process.env.AMAZON_PAY_V2_PUBLIC_KEY_ID,
  UPPY_HOST: process.env.UPPY_HOST,
  UPPY_SOURCES: ["qr", 'ancestry', 'familysearch'],
  FILESTACK_API_KEY: process.env.FILESTACK_API_KEY,
  FILESTACK_DISABLED: false,
  IMAGIFER_URL: process.env.IMAGIFER_URL,
  REDIS_URL: process.env.REDIS_URL,
  ANCESTRY_CLIENT_ID: process.env.ANCESTRY_CLIENT_ID,
  ANCESTRY_REDIRECT_URI: process.env.ANCESTRY_REDIRECT_URI,
  YOUTUBE_URL: 'https://www.youtube.com/channel/UCqzbyXfGVjXe6UWAR3MiF5Q',
  X_URL: 'https://x.com/mycanvas',
  FACEBOOK_URL: 'https://www.facebook.com/PrintMyCanvas',
  INSTAGRAM_URL: 'https://www.instagram.com/print_mycanvas/',
  PINTEREST_URL: 'https://www.pinterest.com/print_mycanvas',
  HELPDESK_URL: 'https://intercom.help/mycanvas/en/',
  STATUS_URL: 'https://status.mycanvas.com/',
  MYCANVAS_CLASSIC_API_URL: process.env.MYCANVAS_CLASSIC_API_URL,
  POLOTNO_API_KEY: process.env.POLOTNO_API_KEY,
  POLOTNO_REMOTE_PDFER_URL: process.env.POLOTNO_REMOTE_PDFER_URL,
  GOOGLE_API_KEY: process.env.GOOGLE_API_KEY,
  GEDCOM_API_URL: process.env.GEDCOM_API_URL,
  GEDCOM_ANALYZER_URL: process.env.GEDCOM_ANALYZER_URL,
  DRAFTS_WSS_URL: process.env.DRAFTS_WSS_URL,
  // Staging only (set in env/mycanvas-web.beta.env): generator session IDs are
  // recorded in the draft and listed in the editor header Debug menu.
  GENERATOR_DEBUG: process.env.GENERATOR_DEBUG === 'true',
  SCRIPTS: {
    ROLLBAR_CLIENT_ACCESS_TOKEN: process.env.ROLLBAR_CLIENT_ACCESS_TOKEN,
    ROLLBAR_ENV: process.env.ROLLBAR_ENV,
    GTAG_ID: process.env.GTAG_ID,
    INTERCOM_APP_ID: 'ymmgw2dx',
    OMNISEND_ID: '5f53a72b8a48f7095faa0e66',
    FACEBOOK_PIXEL_ID: process.env.FACEBOOK_PIXEL_ID,
    LOGDNA_INGESTION_KEY: '34612c2a9c9c9b00710c0a4f05a264ba',
    COMMIT_HASH: process.env.COMMIT_HASH,
    POSTHOG_KEY: process.env.POSTHOG_KEY,
    POSTHOG_HOST: process.env.POSTHOG_HOST,
  },
  EDITOR_WHITE_LABELED_DOMAINS: [
    /(?:http|https)\S+mycanvas\S+amazonaws.com(?:\s|\S)+/,
    /(?:http|https)\S+amazonaws.com\S+mycanvas(?:\s|\S)+/,
  ],
  NEWSLETTER_URL:
    'https://omniform1.com/signup/v1/5f53a72b8a48f7095faa0e66_60b6863a4c7fa4331d2a7d2a.html',
};

export const updateSettings = (override = {}) => {
  Object.entries(override).forEach(([key, value]) => {
    SETTINGS[key] = value;
  });

  componentsInit(SETTINGS, images);
  ecommerceInit(SETTINGS);
  dataInit(SETTINGS);
  editorInit(SETTINGS);
};

updateSettings();

export default SETTINGS;
